// @flow
export const DEFAULT_NUMBER_OF_ITEMS_TO_SHOW_ON_HOME_PAGE = 10;
export const MAXIMUM_NUMBER_OF_ACCOUNTS_PER_PAGE_ON_HOME_PAGE = 10;
export const LIMIT_INDICATOR_FOR_FETCH_ALL = -1;
export const STREAMING_PROJECTS_ROUTE_IDENTIFIER = 'streaming-projects';
export const STREAMING_PROJECTS_API = 'streamingProjectsApi';
export const NO_FREE_RESOURCE_MESSAGE =
  'No free resource found - Either add a new resource or free up an existing resource!';
export const ADD_NEW_WORKLOAD_MESSAGE = 'Add New Workload';
/**
 * Temporary flag to enable/disable the commit details accordion.
 * TODO::SP Remove variable and usage once ready for release
 */
export const IS_DEFAULT_COMMIT_SECTION_LIVE = true;

export const IS_USER_COMMIT_SECTION_LIVE = true;
export const IS_ORG_SHARING_LIVE = true;
export const IS_USER_COMMITS_DISCOUNTS_PUSH_TO_SFDC_LIVE = true;
export const IS_CNBC_SECTION_LIVE = true;
export const IS_ORG_COPY_LIVE = true;
export const IS_DEDICATED_PARTITIONS_LIMIT_EXTENSION_LIVE = true;
export const IS_COMMIT_CUSTOM_VIEWS_ENABLED = true;
export const IS_COMMIT_SFDC_VIEWS_LIVE = true;
export const IS_FREIGHT_CONNECTOR_LIVE = true;
export const IS_MLD_IN_COMMIT_LIVE = true;

export const IS_TABLE_FLOW_LIVE = true;
export const GLOBAL_DISCOUNT_MAX_THRESHOLD_FOR_NON_ADMIN = 25;
export const IS_VBD_LIVE = true;
export const IS_SPLITTING_OF_PL_AND_PNI_IN_ENTERPRISE_CLUSTER_CONFIG_LIVE = true;

/**
 * Temporary flag to enable/disable the cost and margin columns
 * in Streaming Projects Pricing Summary.
 * TODO::SP Remove variable and usage once ready for release
 */
export const IS_COST_AND_MARGIN_COLUMNS_ENABLED = true;

/**
 * Temporary flag to enable/disable the total row pinning
 * in Streaming Projects Pricing Summary.
 * TODO::SP Remove variable and usage once ready for release
 */
export const IS_PINNING_TOTAL_ROW_ENABLED = true;

export const DISCOUNT_EXCEEDING_25_PERCENT_MESSAGE =
  'Contact deal strategy for discounts greater than 25%';

export const EARLY_ACCESS_USERS_LIST = [
  'achauhan@confluent.io',
  'vgundamaraju@confluent.io',
  'atomar@confluent.io',
  'pede@confluent.io',
  'nik@confluent.io',
  'lgarg@confluent.io',
  'dnidwannaya@confluent.io',
  'lchawla@confluent.io',
  'cshingala@confluent.io',
  'ssarwar@confluent.io',
  'mmalani@confluent.io',
  'ksoma@confluent.io',
  'gcunningham@confluent.io',
  'jyoti@confluent.io',

  // new UAT users
  'ewatkins@confluent.io',
  'ctullysmith@confluent.io',
  'rmarkham@confluent.io',
  'luke@confluent.io',
  'oporus@confluent.io',
  'mberindetampanariu@confluent.io',
  'inesi@confluent.io',
  'olaplace@confluent.io',
  'tkotibhaskar@confluent.io',
  'rvyas@confluent.io',
  'jnichols@confluent.io',
  'aong@confluent.io',
  'thad@confluent.io',
  'grand@confluent.io',
  'ecukuroglu@confluent.io',
];
